import { ApolloError } from '@apollo/client';
import i18n from 'i18next';
import { errorCodeMap } from '../constants/errorCodeMap';

export function getBackendErrorMessage(
  error: ApolloError,
  fallback: string = 'common.genericBackendError',
) {
  const responseJson =
    error.graphQLErrors[0].extensions?.exception?.responseBody;

  let errorKey;

  if (responseJson) {
    const errorResponse = JSON.parse(responseJson);
    errorKey = errorCodeMap.get(errorResponse.code);
  }

  return i18n.t(errorKey ?? fallback);
}
